<div class="container-fluid">
  <app-page-header-with-button
    title="Orçamentos"
    icon="fas fa-file-invoice-dollar"
    subtitle="Gerencie os orçamentos do sistema"
    buttonText="Novo Orçamento"
    buttonIcon="fas fa-plus"
    [buttonDisabled]="!podeEditar"
    (buttonClick)="novoOrcamento()">
  </app-page-header-with-button>

  <!-- Filtros -->
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="fas fa-filter me-2"></i>
        Filtros
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="filtroForm">
        <div class="row">
          <div class="col-md-4">
            <label for="Projeto" class="form-label">Projeto</label>
            <input type="text" class="form-control form-control-sm" id="Projeto" formControlName="Projeto"
              placeholder="Buscar por projeto...">
          </div>
          <div class="col-md-4">
            <label for="Cliente" class="form-label">Cliente</label>
            <input type="text" class="form-control form-control-sm" id="Cliente" formControlName="Cliente"
              placeholder="Buscar por cliente...">
          </div>
          <div class="col-md-2">
            <label for="QuantidadePorPagina" class="form-label">Itens por página</label>
            <select class="form-select form-select-sm" id="QuantidadePorPagina" formControlName="QuantidadePorPagina"
              (change)="onQuantidadePorPaginaChange()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
            </select>
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button type="button" class="btn btn-outline-secondary btn-sm w-100 mt-2" (click)="limparFiltros()">
              <i class="fas fa-eraser me-1"></i>
              Limpar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Mensagem de erro -->
  <div *ngIf="erro403" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    Você não tem permissão para acessar esta página.
  </div>

  <div *ngIf="!erro403 && error && !isLoading" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
  </div>

  <!-- Loading -->
  <div *ngIf="!erro403 && isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
    <p class="mt-2 text-muted">Carregando orçamentos...</p>
  </div>

  <!-- Lista de Orçamentos -->
  <div *ngIf="!erro403 && !isLoading" class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Orçamentos ({{ pagination.totalDeItens }})
      </h5>
    </div>
    <div class="card-body p-0">
      <div *ngIf="orcamentos.length === 0" class="text-center py-5">
        <i class="fas fa-file-invoice-dollar fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Nenhum orçamento encontrado</h5>
        <p class="text-muted">Nenhum orçamento foi encontrado com os filtros aplicados.</p>
      </div>

      <div *ngIf="orcamentos.length > 0" class="table-responsive">
        <table class="table table-hover table-striped mb-0">
          <thead class="table-light">
            <tr>
              <th class="px-3 py-2 text-center actions-column">Ações</th>
              <th class="px-3 py-2">Projeto</th>
              <th class="px-3 py-2">Descrição</th>
              <th class="px-3 py-2">Medidas</th>
              <th class="px-3 py-2 text-end">Valor Total</th>
              <th class="px-3 py-2">Status</th>
              <th class="px-3 py-2">Data Cadastro</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let orcamento of orcamentos">
              <td class="text-center actions-column">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  [disabled]="!podeEditar"
                  (click)="visualizarOrcamento(orcamento)"
                  [title]="!podeEditar ? 'Sem permissão para visualizar' : 'Visualizar Orçamento'"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </td>
              <td class="px-3 py-2">
                <div>
                  <strong>{{ orcamento.descricaoProjeto || '-' }}</strong>
                </div>
                <div *ngIf="orcamento.nomeCliente" class="small text-muted mt-1">
                  {{ orcamento.nomeCliente }}
                </div>
              </td>
              <td class="px-3 py-2">
                {{ orcamento.descricao || '-' }}
              </td>
              <td class="px-3 py-2">
                <div *ngIf="orcamento.comprimento || orcamento.largura" class="small">
                  <div>
                    <span *ngIf="orcamento.comprimento">C: {{ formatarMedida(orcamento.comprimento) }}m</span>
                    <span *ngIf="orcamento.comprimento && orcamento.largura"> | </span>
                    <span *ngIf="orcamento.largura">L: {{ formatarMedida(orcamento.largura) }}m</span>
                  </div>
                  <div *ngIf="orcamento.comprimentoSobrepor || orcamento.larguraSobrepor" class="mt-1">
                    <span *ngIf="orcamento.comprimentoSobrepor">C.So.: {{ formatarMedida(orcamento.comprimentoSobrepor) }}m</span>
                    <span *ngIf="orcamento.comprimentoSobrepor && orcamento.larguraSobrepor"> | </span>
                    <span *ngIf="orcamento.larguraSobrepor">L.So.: {{ formatarMedida(orcamento.larguraSobrepor) }}m</span>
                  </div>
                </div>
                <span *ngIf="!orcamento.comprimento && !orcamento.largura" class="text-muted">-</span>
              </td>
              <td class="px-3 py-2 text-end">
                <strong>{{ formatarMoeda(orcamento.totalVenda) }}</strong>
              </td>
              <td class="px-3 py-2">
                <span [ngClass]="getStatusClass(orcamento.statusOrcamento)">
                  {{ formatarStatus(orcamento.statusOrcamento) }}
                </span>
              </td>
              <td class="px-3 py-2">
                {{ (orcamento.dataCadastro | date:'dd/MM/yyyy') || '-' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginação -->
    <div *ngIf="!isLoading && pagination.totalDeItens > 0" class="card-footer">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            <span *ngIf="pagination.totalDeItens > 0">
              Mostrando {{ (pagination.paginaAtual - 1) * pagination.quantidadePorPagina + 1 }} até
              {{ (pagination.paginaAtual * pagination.quantidadePorPagina) > pagination.totalDeItens ?
              pagination.totalDeItens : (pagination.paginaAtual * pagination.quantidadePorPagina) }} de
              {{ pagination.totalDeItens }} registros
            </span>
            <span *ngIf="pagination.totalDeItens === 0">
              Nenhum registro encontrado
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ngb-pagination [page]="pagination.paginaAtual" [pageSize]="pagination.quantidadePorPagina"
              [collectionSize]="pagination.totalDeItens" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
              (pageChange)="onPageChange($event)" class="pagination-rounded justify-content-end">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

